import { render } from "./SelectorSourceCategories.vue?vue&type=template&id=7584a623&scoped=true"
import script from "./SelectorSourceCategories.vue?vue&type=script&lang=js"
export * from "./SelectorSourceCategories.vue?vue&type=script&lang=js"

import "./SelectorSourceCategories.vue?vue&type=style&index=0&id=7584a623&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7584a623"]])

export default __exports__